module.exports = __webpack_public_path__ + "static/media/imgSurvey.53645984.svg";